import getTrackPayload from './getTrackPayload';
import { TRACK_EVENT } from './constants';

const trackAction = payload => ({
  type: TRACK_EVENT,
  meta: {
    [TRACK_EVENT]: payload
  }
});

export const track = (key, properties) => {
  return trackAction(getTrackPayload(key, properties || {}));
};